import React, {useState} from 'react';
import './GrantCrystalsPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {API_BASE} from '../../../utils/apiConfig';

const PAGE_ID = 'GrantCrystalsPage';

function GrantCrystalsPage({targetUserId, targetUserName, onBack}) {
  usePageAnalytics('GrantCrystalsPage');
  const [amount, setAmount] = useState('');
  const [granting, setGranting] = useState(false);
  const [grantedAmount, setGrantedAmount] = useState(null);

  const handleGrant = async () => {
    const parsedAmount = parseInt(amount, 10);
    if (!parsedAmount || parsedAmount <= 0 || granting) return;

    setGranting(true);
    setGrantedAmount(null);
    try {
      const response = await fetch(`${API_BASE}/admin/grant-crystals`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({targetUserId, amount: parsedAmount}),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.error || 'Failed to grant crystals');
      }

      setGrantedAmount(parsedAmount);
      setAmount('');
      setTimeout(() => setGrantedAmount(null), 1500);
    } catch (e) {
      console.error('Grant crystals error', e);
      alert(e.message || 'Не удалось начислить кристаллы');
    } finally {
      setGranting(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleGrant();
    }
  };

  return (
    <>
      <h1 className="lobby-page-title grant-crystals-page-title">
        Начислить кристаллы
        {targetUserName && <span className="grant-crystals-page-subtitle">{targetUserName}</span>}
      </h1>

      <div className="grant-crystals-form">
        <label className="grant-crystals-label" htmlFor="grant-crystals-amount">
          Количество кристаллов
        </label>
        <input
          id="grant-crystals-amount"
          className="grant-crystals-input"
          type="number"
          min="1"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Например, 100"
          disabled={granting}
        />

        <PageButton
          className="grant-crystals-submit"
          onClick={handleGrant}
          pageId={PAGE_ID}
          buttonId="grant"
          disabled={granting || !amount || parseInt(amount, 10) <= 0}
        >
          {granting ? 'Начисление...' : 'Начислить'}
        </PageButton>

        {grantedAmount !== null && (
          <div className="grant-crystals-success">
            Начислено {grantedAmount.toLocaleString('ru-RU')} кристаллов
          </div>
        )}
      </div>

      <div className="main-menu-buttons grant-crystals-page-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default GrantCrystalsPage;
